import styled from 'styled-components'
import { Radio, Input } from 'antd'

export const AggregateRadio = styled(Radio.Group)`
  margin-bottom: 10px !important;
`

export const NameSearch = styled(Input.Search)`
  margin-bottom: 10px;
`